"use client";

import { ReactNode } from "react";
import {
  RefundableOptions,
  RefundableProvider,
} from "protect-group-pulse-react";

export default function ProtectGroupContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  // Always wrap children with RefundableProvider on the client.
  // The provider and its hooks require sessionStorage which is client-only,
  // but since this is a "use client" component, it will only render on the client.
  // We must NOT conditionally remove the provider wrapper as this causes
  // context to be undefined during router.refresh() transitions, breaking
  // hooks like useRefundableActions() in child components.
  const options: RefundableOptions = {
    currencyCode: "NZD",
    environment: "prod", // default is 'prod' --> set to 'test' for sandbox
    languageCode: "en",
    useSaleAction: false,
    vendorCode: "ven_local_dc03fed25f0a40a7bc13502c1d554196",
  };

  return <RefundableProvider options={options}>{children}</RefundableProvider>;
}
